module.exports = __webpack_public_path__ + "static/media/009yhkgl.0c9463fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/009yhkgl.jpg
// module id = 631
// module chunks = 0 1